import {
  AfterViewInit,
  Component,
  EventEmitter,
  Input,
  OnInit,
  Output,
} from '@angular/core';
import { FormControl, FormGroup } from '@angular/forms';
import { Config } from '../models/config';
import { KeysPipe } from '../pipes/keys.pipe';
@Component({
  // tslint:disable-next-line: component-selector
  selector: 'paper-otp',
  templateUrl: './paper-otp.component.html',
  styleUrls: ['./paper-otp.component.scss'],
})
export class PaperOtpComponent implements OnInit, AfterViewInit {
  @Input() config: Config = { length: 4 };
  @Input() is_error = false;
  @Input() isDisabled = false;
  @Input()
  otpReload!: EventEmitter<void>;
  // eslint-disable-next-line @angular-eslint/no-output-on-prefix
  @Output() onInputChange = new EventEmitter<string>();

  otpForm: FormGroup;
  inputControls: FormControl[] = new Array(this.config.length);
  componentKey =
    Math.random().toString(36).substring(2) + new Date().getTime().toString(36);
  inputType: string;
  isPasteEvent: boolean = false;
  value = '';
  constructor(private keysPipe: KeysPipe) {
    this.otpForm = new FormGroup({});
    this.inputType = this.getInputType();
  }

  ngOnInit() {
    for (let index = 0; index < this.config.length; index++) {
      this.otpForm.addControl(this.getControlName(index), new FormControl());
    }
    this.subscribeToReloadEmitter();
    this.inputType = this.getInputType();
  }

  subscribeToReloadEmitter(): void {
    this.otpReload.subscribe(() => {
      this.setValue(null);
    });
  }
  ngAfterViewInit(): void {
    if (!this.config.disableAutoFocus) {
      const containerItem = document.getElementById(`c_${this.componentKey}`);
      if (containerItem) {
        containerItem.addEventListener('paste', (evt) => {
          this.isPasteEvent = true;
          this.handlePaste(evt);
        });
        const ele: any =
          containerItem.getElementsByClassName('paper-otp__input')[0];
        if (ele?.focus) {
          ele.focus();
        }
      }
    }
  }
  private getControlName(idx: number) {
    return `ctrl_${idx}`;
  }

  ifLeftArrow(event: any) {
    return this.ifKeyCode(event, 37);
  }

  ifRightArrow(event: any) {
    return this.ifKeyCode(event, 39);
  }

  ifBackspaceOrDelete(event: any) {
    return (
      event.key === 'Backspace' ||
      event.key === 'Delete' ||
      this.ifKeyCode(event, 8) ||
      this.ifKeyCode(event, 46)
    );
  }

  ifKeyCode(event: any, targetCode: number) {
    const key = event.keyCode || event.charCode;
    // tslint:disable-next-line: triple-equals
    return key == targetCode ? true : false;
  }
  onKeyDown($event?: any) {
    if ($event) {
      const isSpace = this.ifKeyCode($event, 32);
      if (isSpace) {
        // prevent space
        return false;
      }
    }
    return true;
  }

  onKeyUp($event: any, inputIdx: number) {
    const nextInputId = this.appendKey(`otp_${inputIdx + 1}`);
    const prevInputId = this.appendKey(`otp_${inputIdx - 1}`);
    if (this.ifRightArrow($event)) {
      this.setSelected(nextInputId);
      return;
    }
    if (this.ifLeftArrow($event)) {
      this.setSelected(prevInputId);
      return;
    }
    const isBackspace = this.ifBackspaceOrDelete($event);
    if (isBackspace && !$event.target?.value) {
      this.setSelected(prevInputId);
      this.rebuildValue();
      return;
    }
    if (!$event.target?.value || this.isDisabled) {
      return;
    }
    if (this.ifValidEntry($event)) {
      if ($event.key !== $event.target?.value) {
        this.otpForm
          .get(this.getControlName(inputIdx))
          ?.setValue($event.target?.value);
      }
      this.setSelected(nextInputId);
    }
    if (!this.isPasteEvent && this.ifValidEntry($event)) {
      this.rebuildValue();
    }
  }

  onInput($event: any, inputIdx: number) {
    const isAndroid = /Android/i.test(navigator.userAgent);
    const original = $event.target.value;
    const filtered = original.replace(/[^0-9]/g, ''); // Only allow digits
    if (this.config.allowNumbersOnly && isAndroid) {
      if (filtered !== original) {
        $event.target.value = filtered;
      }

      this.otpForm.get(this.getControlName(inputIdx))?.setValue(filtered);
    }
  }

  appendKey(id: string) {
    return `${id}_${this.componentKey}`;
  }

  setSelected(eleId: string) {
    this.focusTo(eleId);
    const ele = document.getElementById(eleId) as HTMLInputElement;
    if (ele?.setSelectionRange) {
      setTimeout(() => {
        ele.setSelectionRange(0, 1);
      }, 0);
    }
  }

  ifValidEntry(event: any) {
    const inp = String.fromCharCode(event.keyCode);
    const whitelistedKeyCode = this.config.allowKeyCodes || [];
    const isMobile = /iPhone|iPad|iPod|Android/i.test(navigator.userAgent);
    return (
      isMobile ||
      (/[a-zA-Z0-9-_]/.test(inp) && !this.config.allowNumbersOnly) ||
      (/\d/.test(inp) && this.config.allowNumbersOnly) ||
      whitelistedKeyCode.includes(event?.keyCode) ||
      (event.keyCode >= 96 && event.keyCode <= 105)
    );
  }

  focusTo(eleId: string) {
    const ele: any = document.getElementById(eleId);
    if (ele) {
      ele.focus();
    }
  }

  // method to set component value
  setValue(value: any) {
    if (this.config.allowNumbersOnly && isNaN(value)) {
      return;
    }
    this.otpForm.reset();
    if (!value) {
      this.rebuildValue();
      return;
    }
    value = value.toString().replace(/\s/g, ''); // remove whitespace
    Array.from(value).forEach((c, idx) => {
      if (this.otpForm.get(this.getControlName(idx))) {
        this.otpForm.get(this.getControlName(idx))?.setValue(c);
      }
    });
    if (!this.config.disableAutoFocus) {
      const containerItem = document.getElementById(`c_${this.componentKey}`);
      const indexOfElementToFocus =
        value.length < this.config.length
          ? value.length
          : this.config.length - 1;
      let ele: any =
        containerItem?.getElementsByClassName('otp-input')[
          indexOfElementToFocus
        ];
      if (ele?.focus) {
        ele.focus();
      }
    }
    this.rebuildValue();
  }

  rebuildValue() {
    let val = '';
    this.keysPipe.transform(this.otpForm.controls).forEach((k) => {
      if (this.otpForm.controls[k].value) {
        val += this.otpForm.controls[k].value;
      }
    });
    this.value = val;
    this.onInputChange.emit(val);
  }
  getInputType(): string {
    if (this.config.isPasswordInput) {
      console.log('password');
      return 'password';
    } else if (this.config.allowNumbersOnly) {
      return 'tel';
    }

    return 'text';
  }
  handlePaste(e: any) {
    // Get pasted data via clipboard API
    let clipboardData = e.clipboardData || window.Clipboard;
    let pastedData;
    if (clipboardData) {
      pastedData = clipboardData.getData('Text');
    }
    // Stop data actually being pasted into div
    e.stopPropagation();
    e.preventDefault();
    if (this.isDisabled || !pastedData) {
      return;
    }
    this.setValue(pastedData);
  }

  isValid(index: any) {
    return (
      !!this.otpForm.get(this.getControlName(index))?.value &&
      this.config.entryPoint === 'paper-pin-input'
    );
  }

  get isError() {
    return this.is_error && this.value.length === 6;
  }
}
